/**
 * Create a record of an existing entity type (CT-5525): a Customer or a Company
 * as a RECORD, never a tenant or an entity.
 *
 * Real signature and snake_case body; only the transport is stubbed.
 *
 *   customers  { full_name, email, phones: [{ number, is_primary }], location, owner_id }
 *   companies  { name, domain, industry, city, owner_id }
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

/** `{ id, entityType }` of the record that was created. */
export const mapApiCreatedEntityToUi = (raw = {}) => ({
  id: raw.entity_id ?? raw.entityId ?? raw.id ?? '',
  entityType: raw.entity_type ?? raw.entityType ?? null,
});

/**
 * Answers 409 when the record already exists (the body then carries the
 * matches), 403 when the caller may not create this type, 422 for a payload
 * missing what the type requires.
 *
 * TODO(CT-5525 / backend): `POST /v0/profile/entities/create` is assumed.
 */
export const createEntity = async ({ entityType, values } = {}) => {
  const response = await request('/v0/profile/entities/create', {
    entity_type: entityType,
    values,
  });
  return validateApiResponse(response, 'Failed to create the record');
};
